import { get } from 'lodash';
import React from 'react';
import { NACHWEIS_POSITION_STATUS } from 'src/lib/constants/constant';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import { TreeNodeType } from 'src/lib/types/types';
import { MATreeStructureAbschluss } from '../default-content/abschluss-seite/MATreeStructureAbschluss';
import { TreeStructureAnlagenMA } from '../default-content/anlagen/TreestructureAnlagenMA';
import { TreeStructureErklaerungMA } from '../default-content/erklaerung/TreestructureErklaerungMA';
import { getFormStrucStammdatenblattMA } from '../default-content/stammdatenblatt/content/StammdatenblattMA';
import { TreeStructureWichtigeHinweiseMA } from '../default-content/wichtige-hinweise/TreeStructureWichtigeHinweiseMA';
import BescheidDatenMAEpz from './content/BescheidDatenMAEpz';
import { FoerderungenAndererMittelgeberMAEpz, getFormstrucFoerderungenAndererMittelgeberMAEpz } from './content/FoerderungenAndererMittelgeberMAEpz';
import { MittelabrufEpz } from './content/MittelabrufEpz';
import { getFormstrucProjektausgabenMAEpz, ProjektausgabenMAEpz } from './content/ProjektausgabenMAEpz';
import ProjektDatenMAEpz from './content/ProjektdatenMAEpz';

const MA_P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const hasNachweispositionCommentByStatus = (application: any, status: string) => {
	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
	const nachweisposition = (nachweispositionen as any[]).find((eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
	return Boolean(String(get(nachweisposition, NP_P.Pruefung_Hinweis_Fuer_Den_Antragsteller.path, '')).trim());
};

export const TreeStructureMaEpz = (application: any) => {
	const hasCommentProjektausgaben =
		hasNachweispositionCommentByStatus(application, NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben) ||
		hasNachweispositionCommentByStatus(application, NACHWEIS_POSITION_STATUS.geplant);

	let treeNodes: TreeNodeType[] = [
		...TreeStructureWichtigeHinweiseMA(application),
		{
			label: 'Projektdaten',
			content: <ProjektDatenMAEpz />,
			formStruc: getFormStrucStammdatenblattMA(application),
		},
		{
			label: 'Übersicht Bewilligung',
			content: <BescheidDatenMAEpz />,
		},
		{
			label: 'Projektausgaben',
			content: <ProjektausgabenMAEpz />,
			formStruc: getFormstrucProjektausgabenMAEpz(application),
			hasComment: hasCommentProjektausgaben,
		},
		{
			label: 'Mittelabruf',
			content: <MittelabrufEpz />,
		},
		{
			label: 'Förderungen anderer Mittelgeber',
			content: <FoerderungenAndererMittelgeberMAEpz />,
			formStruc: getFormstrucFoerderungenAndererMittelgeberMAEpz(application),
		},
		...TreeStructureAnlagenMA(application),
		...TreeStructureErklaerungMA(application),
		...MATreeStructureAbschluss(application),
	];

	return treeNodes;
};
